import HttpService from "@core/services/http/http.service";
import {
  Account,
  LoginResponse,
  SignUpRequest,
  SignUpResponse,
} from "@app/types";

class _AuthService {
  public loginWithoutOtp(username: string, password: string) {
    return HttpService.post<any>("/auth/login-without-otp", {
      body: {
        username: username.trim(),
        password: password.trim(),
      },
    });
  }

  public login(username: string, password: string, otp: string) {
    return HttpService.post<LoginResponse>("/auth/login", {
      body: {
        username: username.trim(),
        password: password.trim(),
        otp: otp.trim(),
      },
    });
  }

  public signUp(signUpRequest: SignUpRequest) {
    return HttpService.post<SignUpResponse>("/auth/register", {
      body: { ...signUpRequest },
    });
  }

  public getOtp(action?: string) {
    return HttpService.get<Account>("/auth/otp", { queryParams: { action } });
  }

  public forgetPassword(payload: { username: string; email: string }) {
    return HttpService.post<any>("/auth/forget-password", {
      body: {
        username: payload.username.trim(),
        email: payload.email.trim(),
      },
    });
  }

  /** Đổi mật khẩu khi đang đăng nhập: API bắt buộc mật khẩu cũ */
  public changePassword(oldPassword: string, password: string) {
    return HttpService.post<any>("/auth/change-password", {
      body: {
        oldPassword,
        password,
      },
    });
  }

  /** Đặt lại mật khẩu từ link trong email quên mật khẩu (chưa đăng nhập): token gửi trong body, dùng 1 lần */
  public resetPassword(password: string, token: string) {
    return HttpService.post<any>("/auth/reset-password", {
      body: {
        token,
        password,
      },
    });
  }
}

const AuthService = new _AuthService();

export default AuthService;
